import React, { Component } from 'react';
import ShopifyModal from "../../../../../components/ShopifyModal";

import { BlockStack, ChoiceList, Toast, Box } from '@shopify/polaris';

import { reqPostApplyRules } from '../../../../../api';

import intl from '../../../../../i18n/intl'

class ApplyRules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.show ? true : false,
      selectedUpdateType: ['price'],
      selectedUpdateScope: ['not_imported'],

      //弹窗
      showToast: false,  //弹窗显示
      showToastText:'',  //弹窗文字
      showToastIserror:false, //弹窗是否错误
      applyButtonLoading: false,
    };
  }

  componentDidMount() {}

  // 组件渲染完成，再次修改渲染内容
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      active: this.props.show ? true : false,
      selectedUpdateType: ['price'],
      selectedUpdateScope: ['not_imported'],

      //弹窗
      showToast: false,  //弹窗显示
      showToastText:'',  //弹窗文字
      showToastIserror:false, //弹窗是否错误
      applyButtonLoading: false,
    });
  }

  //提示弹窗
  toggleToast = (showToastText, showToastIserror=false) => {
    this.setState(({ showToast }) => ({
      showToast: showToastText !== "",
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };

  handleApplyRules = async() =>{

    this.setState({applyButtonLoading: true});
      const params = {
        type: JSON.stringify(this.state.selectedUpdateType),
        scope: JSON.stringify(this.state.selectedUpdateScope)
      };
      const response = await reqPostApplyRules(params);
      this.setState({applyButtonLoading: false});
      if (response.code === "200") {

        this.toggleToast('Price updating...', false);
        this.handleChange();

        // 父级重新显示更新数据
        this.props.callBackFun({count: response.data.implement_number});
        
      }else{
        this.toggleToast(response.msg);
      }
    
  }

  handleChange = () =>{
    this.setState(({ active }) => ({ active: !active }));
  }

  handleChoiceChange = (type,value) =>{
    if(type === 'type'){
      this.setState({
        selectedUpdateType: value,
      });
    }

    if(type === 'scope'){
      this.setState({
        selectedUpdateScope: value,
      });
    }
  }

  render() {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={()=>this.toggleToast('')} error={this.state.showToastIserror} /> : null;
    const { active,selectedUpdateType ,selectedUpdateScope,applyButtonLoading } = this.state;

    return (
      <div>
        <ShopifyModal id="apply-rules"
          open={active}
          onClose={this.handleChange}
          heading={intl.get("Apply pricing rules to products")}
          primaryAction={{
            content: intl.get("Apply"),
            onAction: this.handleApplyRules,
            loading: applyButtonLoading
          }}
          secondaryActions={[
            {
              content: intl.get("Cancel"),
              onAction: this.handleChange,
            },
          ]}
        >
          <div>Applying price rules will update product prices. Shipping fees apply only to Dropshipman products, not to AliExpress or Temu.</div>
            <div style={{padding:'0.5rem 1rem'}}></div>
            <BlockStack gap={200}>
                <Box className="select_update_type">
                <ChoiceList
                  heading={intl.get("Select the update type")}
                  choices={[
                    {label: intl.get("Selling Price"), value: 'price'},
                    {label: intl.get("Original price "), value: 'compared_at_prices'},
                    {label: intl.get("Selling Price and Original Price"), value: 'all_prices'},
                  ]}
                  selected={selectedUpdateType}
                  onChange={(value)=>this.handleChoiceChange('type',value)}
                />
                </Box>
              <Box className="select_update_type">
                <ChoiceList
                  heading={intl.get("Select the update scope")}
                  choices={[
                    {label: intl.get("Not Listed Products"), value: 'not_imported'},
                    {label: intl.get("Listed Products"),value: 'shop'},
                    {label: intl.get("Not Listed and Listed Products"), value: 'all_products'},
                  ]}
                  selected={selectedUpdateScope}
                  onChange={(value)=>this.handleChoiceChange('scope',value)}
                />
                </Box>
            </BlockStack>

          </ShopifyModal>

        {toastMarkup}
      </div>
    );
  }
}

export default ApplyRules;
